import $ from 'jquery';

//Form post-submission scroll to view and set download...
if (typeof $$epiforms !== 'undefined') {
	$$epiforms(document).ready(function myfunction() {

		$$epiforms(".bidwells-form").on("formsSubmitted",
			function (event, param1, param2) {
				if (event.returnedResult?.isSuccess && event.returnedResult?.message.length > 0) {
					$$epiforms(event.currentTarget).find('.Form__SubmissionSuccess__Message').html(event.returnedResult.message);
				}
				this.closest(".grid-container")?.scrollIntoView();
				this.closest(".gateddownload")?.scrollIntoView();
			});
	});
}